import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import * as socketIo from 'socket.io-client';
import { Socket } from '../model/socket.model';
import { environment } from '../../../environments/environment';

declare var io : {
  connect(url: string): Socket;
};

@Injectable()
export class SocketService<T> {
  private socket: Socket;
  observer: Observer<T>;

  constructor() { 
    // console.log(environment.WEBSOCKET); this.socket = socketIo(environment.WEBSOCKET,{extraHeaders:{Authorization:sessionStorage.getItem('sessionkey')}});
   }

  public RecieveEvents(data:string) : Observable<T> {
    this.socket.on(data, (res) => {     
      this.observer.next(res);
    });
    return this.createObservable();
  }

  private createObservable() : Observable<T> {
      return new Observable<T>(observer => {
        this.observer = observer;
      });
  }

  public SendEvents(event:string, data:T) : void{
    console.log("Request for socket connection");
    this.socket.emit(event, data);
  }

  private handleError(error) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
        let errMessage = error.error.message;
        return Observable.throw(errMessage);
    }
    return Observable.throw(error || 'Socket.io server error');
  }
}